const RileylolEpsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static"> 

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/sadoutwest/sets/next-lifetime-ep" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-zeA3BQWMzbUmcj1R-w2smyQ-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>next lifetime</strong>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/2VXHuHreaSJbNPhs7abgBs" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-e1zRZhqy4lPrJaEo-tjXPqg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>rileylol</strong>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/sadoutwest/sets/riley-omu-eden-project-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-mDh5R1HzQiuK2Tln-AOofBw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Eden Project</strong><br/>
              </p>
            </a>
          </div>  

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://soundcloud.com/sadoutwest/sets/crying-in-the-mosh-pit-ep" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-000660612397-aq4bd6-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>crying in the mosh pit</strong><br/>
              </p>
            </a>
          </div>                                                                                                                               
        
        </div>
      </>
    );
  };
  export default RileylolEpsStatic;